import { FormProvider, useForm, useWatch } from "react-hook-form";
import React from "react";
import {
  Checkbox,
  FormGroup,
  SubmitButton,
} from "../../../../@coherent/react-hook-form";
import { Button, ModalBody } from "reactstrap";
import { Trans } from "react-i18next";
import { EthnicityCaptureForm } from "../../../ethnicity_capture/EthnicityCaptureForm";
import { useModal } from "../../../../hooks";

export const Step6Form = () => {
  const isYoungHelper =
    useWatch({
      name: "young_helper",
    }) === "Yes";

  return (
    <>
      <h3 className="tw-text-lg mb-4">
        {isYoungHelper ? "Thank you for your application" : "Keeping in Touch"}
      </h3>
      <p>
        Your data has been collected in accordance with our privacy policy which
        you can access here:{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.tlg.org.uk/other/privacy-policy/privacy-policy-staff-volunteers"
        >
          TLG - Staff & Volunteers Privacy Notice
        </a>
        .
      </p>
      {!isYoungHelper ? (
        <>
          <FormGroup
            label={
              <>
                <p>
                  As a Make Lunch volunteer TLG may contact you, occasionally,
                  with information that is relevant to your role.
                </p>
                <p>
                  We would also love to encourage and support you further by
                  keeping you up to date with everything that is happening
                  across the UK through TLG. Please indicate if you would like
                  to hear more from us in any of the following ways:
                </p>
              </>
            }
            name="contact"
          >
            <FormGroup
              check
              htmlFor="contact_email"
              label="Email - You’ll receive our inspiring email updates celebrating powerful stories"
            >
              <Checkbox
                name="contact_email"
                id="contact_email"
                className="form-check-input"
              />
            </FormGroup>
            <FormGroup
              check
              htmlFor="contact_post"
              label="Post - You’ll receive our FREE fantastic Hope & a future magazine"
            >
              <Checkbox
                name="contact_post"
                id="contact_post"
                className="form-check-input"
              />
            </FormGroup>
            <FormGroup
              check
              htmlFor="contact_phone"
              label="Phone - Hear the difference you are making to TLG – don’t worry we won’t call you frequently"
            >
              <Checkbox
                name="contact_phone"
                id="contact_phone"
                className="form-check-input"
              />
            </FormGroup>
            <FormGroup
              check
              htmlFor="contact_text"
              label="Text/SMS Message - I'm happy for TLG to text me occasionally"
            >
              <Checkbox
                name="contact_text"
                id="contact_text"
                className="form-check-input"
              />
            </FormGroup>
          </FormGroup>
        </>
      ) : (
        <p>
          If you have completed all elements of your application you can now
          click "Submit" - your local Make Lunch Team will be in touch with next
          steps.
        </p>
      )}
    </>
  );
};

export const Step6 = ({ onSubmit: onSubmitProp, defaultValues, onBack }) => {
  const { Modal, isOpen, setIsOpen } = useModal();
  const methods = useForm({
    mode: "onBlur",
    defaultValues,
    shouldUnregister: true,
  });

  const { handleSubmit, setValue, register } = methods;

  const isYoungHelper =
    useWatch({
      name: "young_helper",
      control: methods.control,
    }) === "Yes";

  async function onSubmit(x) {
    return onSubmitProp({
      ...x,
      submit: true,
    });
  }

  async function handleEthnicityCapture(x) {
    setValue("ethnicity_capture", x);
    await handleSubmit(onSubmit)();
    setIsOpen(false);
  }

  async function handlePreSubmit() {
    setIsOpen(true);
  }

  register("ethnicity_capture");

  return (
    <FormProvider {...methods}>
      {isOpen && (
        <Modal size="lg" toggle={null}>
          <ModalBody>
            {!isYoungHelper ? (
              <>
                <Trans>
                  It is important to us that our services are inclusive and
                  reflect the diversity of our communities. Please help us by
                  selecting your ethnicity on the form below. This data is
                  collected anonymously and does not in any way affect your
                  registration.
                </Trans>
                <p className="tw-font-medium">
                  <Trans>
                    If you prefer not to give this information, please choose
                    the last option ‘prefer not to say’
                  </Trans>
                </p>
              </>
            ) : (
              <>
                <p>
                  <Trans>
                    At Make Lunch, we want to make sure that everyone has a fair
                    and equal chance to get involved, no matter their background.
                    To help us understand who is applying and to improve how we
                    reach and support young volunteers, we ask you to answer the
                    following question about your ethnic background.
                  </Trans>
                </p>
                <p>
                  <Trans>
                    This question is:
                  </Trans>
                  <ul>
                    <li>
                      <Trans>
                        <strong>Completely optional</strong> – you can click
                        "prefer not to say".
                      </Trans>
                    </li>
                    <li>
                      <Trans>
                        <strong>Anonymous</strong> – your answer won’t be linked
                        to your name or affect your application.
                      </Trans>
                    </li>
                    <li>
                      <Trans>
                        <strong>Used only for equality monitoring</strong> – to
                        help us make our club more inclusive and welcoming for
                        everyone.
                      </Trans>
                    </li>
                  </ul>
                  <Trans>
                    Thanks for helping us build a more inclusive Make Lunch
                    community!
                  </Trans>
                </p>
              </>
            )}

            <p className="tw-text-lg tw-font-medium">
              <Trans>
                Which of these statements best describes your Ethnicity? (Please
                check the appropriate box):
              </Trans>
            </p>
            <EthnicityCaptureForm onSubmit={handleEthnicityCapture} />
          </ModalBody>
        </Modal>
      )}
      <form onSubmit={handleSubmit(handlePreSubmit)}>
        <Step6Form />
        <div className="tw-flex tw-justify-between">
          <Button onClick={onBack}>Back</Button>
          <SubmitButton>Submit</SubmitButton>
        </div>
      </form>
    </FormProvider>
  );
};
